import React from 'react'
import { Layout } from 'antd'
import Footer from './Footer'
import Header from './Header'
import Loader from '../Loader'
import Sidebar from './Sidebar'
import { useStoreState } from '../../store'

const AppLayout = ({ children }) => {
  const { apiLoading } = useStoreState(state => state.ui)

  return (
    <Layout className="app-layout">
      <Loader show={apiLoading} />
      <Sidebar />
      <Layout style={{ marginLeft: 200 }}>
        <Header />
        <Layout.Content className="app-layout__content">
          {children}
        </Layout.Content>
        <Footer />
      </Layout>
    </Layout>
  )
}

export default AppLayout
